import React from "react";

const Checkbox = React.forwardRef((props, ref ) => {
  return (
      <input
        {...props}
        type="checkbox"
        value={props.value}
        ref={ref}
        checked={props.value ? true : false}
        onChange={(e) => props.onChange(e.target.checked)}
      />
  );
});

export default Checkbox;